import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import OrderSignResult from '../../../components/order-sign-result/order-sign-result';
import { useSignResultHook } from '../../../hooks/signResultHook';
import AppPageMain from '../../../modules/app-page/app-page--main';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import PageHeader from '../../../modules/page-header';

const CfaResultPage: FC = () => {
  const history = useHistory();
  const { success, getDocsBtns } = useSignResultHook('releaseCfa', {
    submitPath: '/orders',
    closePath: '/orders',
  });
  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                { link: '/assets', title: 'Активы' },
                { link: '#', title: 'Выпуск ЦФА' },
              ]}
              iconType="assets"
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <OrderSignResult
              loading={false}
              linkContent={getDocsBtns()}
              submitBtn={
                <IconBtn
                  title="Закрыть и перейти в активы"
                  onClick={() => {
                    history.push('/assets');
                  }}
                />
              }
              success={success}
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default CfaResultPage;
